import { render, staticRenderFns } from "./TheCategories.vue?vue&type=template&id=5bb2c811&"
import script from "./TheCategories.vue?vue&type=script&lang=js&"
export * from "./TheCategories.vue?vue&type=script&lang=js&"
import style0 from "./TheCategories.vue?vue&type=style&index=0&id=5bb2c811&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports